<div layoutDir="row"
    [ngClass]="{'main-title': (!canEdit || !enableEdit)  }" class="title"
    (click)="canEdit && enableEdit   ? turnEditModeOn() : null" (paste)="handlePaste($event)">
    <div #TITLE [attr.contenteditable]="isEditMode && !hideReportControlFeatures"
        (blur)="updateTitle($any($event.target).innerText)">
        {{ mainTitle }}
    </div>
</div>
